import swal2 from 'sweetalert2';
import decode from 'jwt-decode';
import moment from 'moment';

import store from '../store/index';

export default {
  configurarError(error) {
    if (error.response) {
      if (error.response.status) {
        if (error.response.status == 401) {
          this.configurarError401();
        } else if (error.response.status == 402) {
          this.configurarError402();
        } else if (error.response.status == 403) {
          this.configurarError403();
        }
      }
    } else {
      console.error(error);
    }
  },

  configurarError401() {
    swal2
      .fire({
        title:
          "<span style='font-family:Roboto;'>¡Sin Cabacera De Autentación!</span>",
        html: "<span style='font-family:Roboto;'>Vuelve A Iniciar Sesión</span>",
        icon: 'warning',
        confirmButtonColor: '#79c37d',
        confirmButtonText: "<span style='font-family:Roboto;'>Aceptar</span>",
        customClass: 'myCustomClass',
        allowOutsideClick: false,
      })
      .then(result => {
        if (result.isConfirmed == true) {
          store.dispatch('salir');
        }
      });
  },

  configurarError402() {
    store.dispatch('salir');
    swal2.fire({
      title: "<span style='font-family:Roboto;'>¡Su sesión ha expirado!</span>",
      html: "<span style='font-family:Roboto;'>Por favor, vuelva a ingresar</span>",
      icon: 'warning',
      confirmButtonColor: '#79c37d',
      confirmButtonText: "<span style='font-family:Roboto;'>Aceptar</span>",
      customClass: 'myCustomClass',
      allowOutsideClick: false,
    });
  },

  configurarError403() {
    swal2.fire({
      title:
        "<span style='font-family:Roboto;'>¡Sin Permisos Para Acceder A La Información!</span>",
      html: "<span style='font-family:Roboto;'>Comunicarse Con El Administrador.</span>",
      icon: 'warning',
      confirmButtonColor: '#79c37d',
      confirmButtonText: "<span style='font-family:Roboto;'>Aceptar</span>",
      customClass: 'myCustomClass',
      allowOutsideClick: false,
    });
  },

  timeToken() {
    // TOKEN NODEJS
    const decodeToken = decode(store.state.token);
    const expiresIn = decodeToken.exp;
    const time = new Date(expiresIn * 1000);
    const fecha = moment(time).format('DD/MM/YYYY HH:mm:ss');
    const fechaActual = moment().format('DD/MM/YYYY HH:mm:ss');

    if (fecha <= fechaActual) {
      this.configurarError402();
    }
  },
};
